import { Title } from '@factorialco/deprecated-design-system'

// nosemgrep
import PanesPadForm from 'modules/core/components/PanesPadForm'
import i18n from 'modules/core/lib/i18n'

import StatusBlock from 'modules/integrations_primobox/components/StatusBlock'
import type Status from 'modules/integrations_primobox/lib/interfaces/Status'

interface Props {
  status: Status
  cardTitle?: string
  inModal?: boolean
}

const StatusRow = ({ status, cardTitle, inModal = false }: Props) => {
  return (
    <PanesPadForm direction={inModal ? 'vertical' : 'horizontal'}>
      <Title
        variant="400"
        illustration="money-bag"
        title={i18n.t('integrations_primobox.legal_entity_status.title')}
        description={i18n.t('integrations_primobox.legal_entity_status.description')}
      />

      <StatusBlock title={cardTitle} status={status} inModal={inModal} />
    </PanesPadForm>
  )
}

export default StatusRow
